import React from 'react';
import { Box } from '@mui/material';
import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import About from '../components/sections/About';
import Features from '../components/sections/Features';
import Testimonials from '../components/sections/Testimonials';
import FAQ from '../components/sections/FAQ';
import Contact from '../components/sections/Contact';
import Newsletter from '../components/sections/Newsletter';
import { useLanguage } from '../context/LanguageContext';

// SEO content block — visually hidden (sr-only standard), Google indexes it, users don't see it
const SeoFooterBlock = () => (
  <Box
    component="section"
    aria-label="About ITFORSEC services"
    sx={{
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: 0,
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0,
    }}
  >
    <p>
      ITFORSEC is a Security-First Web Development and IT solutions company based in Tbilisi, Georgia.
      We specialize in professional Web Development (ვებ-დეველოპმენტი), custom software development,
      network security, and Advanced Cybersecurity (კიბერუსაფრთხოება) services for businesses across
      Georgia and internationally. Our team provides expert IT Support in Tbilisi, automation scripting,
      Local LLM and private AI setup, and Web3 blockchain development. Whether you need a modern business
      website in Georgia, a penetration test, or a private offline AI assistant — ITFORSEC delivers
      enterprise-grade solutions at accessible prices.
    </p>
    <p lang="ka">
      ITFORSEC გთავაზობთ პროფესიონალურ ვებ-საიტის დამზადებას, IT მხარდაჭერას,
      კიბერუსაფრთხოებასა და ხელოვნური ინტელექტის ლოკალურ ინსტალაციას თბილისში და საქართველოში.
    </p>
  </Box>
);

const Home = () => {
  const { isSectionVisible, newsletterUi } = useLanguage();

  const showMainNewsletter =
    isSectionVisible('newsletter') &&
    newsletterUi?.show_in_main !== false &&
    newsletterUi?.placement !== 'footer';

  return (
    <Box component="main">
      {isSectionVisible('hero') && <Hero />}
      {isSectionVisible('services') && <Services />}
      {isSectionVisible('about') && <About />}
      {isSectionVisible('features') && <Features />}
      {isSectionVisible('testimonials') && <Testimonials />}
      {isSectionVisible('faq') && <FAQ />}
      {isSectionVisible('contact') && <Contact />}
      {showMainNewsletter && <Newsletter />}
      <SeoFooterBlock />
    </Box>
  );
};

export default Home;
